import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Modal, Input, Select, Textarea, Btn } from "@/components/UI";
import { apiError } from "@/lib/customers";
import { TrDateField } from "@/components/common/TrDateField";

const EMPTY = { product_id: "", lot_no: "", qty: "", mfg_date: "", expiry_date: "", notes: "" };

export function LotFormModal({ open, lot, onClose, onSaved }) {
  const [f, setF] = useState(EMPTY);
  const [products, setProducts] = useState([]);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    setF(lot ? { ...EMPTY, ...lot, lot_no: lot.lot_code, mfg_date: lot.mfg_date || "", expiry_date: lot.expiry_date || "", notes: lot.notes || "" } : EMPTY);
    setErr("");
    api.get("/stock").then((rows) => setProducts(rows.map((r) => ({ id: r.product_id, code: r.code, name: r.name }))))
      .catch((e) => setErr(apiError(e, "Ürün listesi yüklenemedi")));
  }, [open, lot]);
  const set = (k) => (e) => { setErr(""); setF({ ...f, [k]: e.target.value }); };

  const save = async () => {
    if (!f.product_id) return setErr("Ürün seçiniz");
    if (!f.lot_no.trim()) return setErr("Lot No zorunludur");
    if (f.mfg_date && f.expiry_date && f.expiry_date <= f.mfg_date) return setErr("SKT üretim tarihinden sonra olmalıdır");
    const payload = { product_id: f.product_id, lot_no: f.lot_no, qty: Number(f.qty || 0), mfg_date: f.mfg_date || null, expiry_date: f.expiry_date || null, notes: f.notes };
    setBusy(true);
    try { lot ? await api.put(`/stock/lots/${lot.id}`, payload) : await api.post("/stock/lots", payload); onSaved(); }
    catch (e) { setErr(apiError(e, "Kaydedilemedi")); }
    finally { setBusy(false); }
  };

  return (
    <Modal open={open} onClose={onClose} title={lot ? "Lot Düzenle" : "Yeni Lot"}>
      <div className="grid grid-cols-2 gap-3" data-testid="lot-form">
        <div className="col-span-2">
          <Select label="Ürün *" value={f.product_id} onChange={set("product_id")} data-testid="lot-form-product">
            <option value="">Seçiniz…</option>
            {products.map((p) => <option key={p.id} value={p.id}>{p.code} — {p.name}</option>)}
          </Select>
        </div>
        <Input label="Lot No *" value={f.lot_no} onChange={set("lot_no")} data-testid="lot-form-lot-no" />
        <Input label="Miktar" type="number" min="0" value={f.qty} onChange={set("qty")} data-testid="lot-form-qty" />
        <TrDateField label="Üretim Tarihi" value={f.mfg_date} onChange={(v) => setF({ ...f, mfg_date: v })} testid="lot-form-mfg" />
        <TrDateField label="SKT" value={f.expiry_date} onChange={(v) => setF({ ...f, expiry_date: v })} testid="lot-form-exp" />
        <div className="col-span-2"><Textarea label="Not" value={f.notes} onChange={set("notes")} data-testid="lot-form-notes" /></div>
        <div className="col-span-2 text-[11px] text-slate-500">Lot kaydı bilgi ve raf ömrü takibi içindir; stok miktarını değiştirmez.</div>
      </div>
      {err && <div className="mt-3 text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-md px-3 py-2" data-testid="lot-form-error">{err}</div>}
      <div className="flex justify-end gap-2 mt-4">
        <Btn variant="secondary" onClick={onClose} data-testid="lot-form-cancel">Vazgeç</Btn>
        <Btn onClick={save} disabled={busy} data-testid="lot-form-save">{busy ? "Kaydediliyor…" : "Kaydet"}</Btn>
      </div>
    </Modal>
  );
}
